import { connect } from 'react-redux'
import { redirect } from 'redux-first-router'

import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import { selectLocationKind } from 'selectors/location'
import { selectDidError } from 'ducks/integrations'

import SettingsModal from './view'

function select(state) {
  return {
    animateModal: selectLocationKind(state) !== 'load',
    error: selectDidError(state),
  }
}

const perform = dispatch => {
  return {
    onClose: function doCloseModal() {
      dispatch(redirect({ type: SETTINGS_INTEGRATIONS_PAGE }))
    },
  }
}

export default connect(select, perform)(SettingsModal)
